//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').component('universalImageActionsProductizeEmptyState', {
    bindings: {
      svgIcon: '@',
      heading: '@',
      htmlMessage: '@',
    },
    template: require('@legacy-components/common/universal-image-actions/universal-image-actions-productize-empty-state.html'),
    controller: [
      '$sce',
      function(
                $sce,
            ) {
        this.message = $sce.trustAsHtml(this.htmlMessage);
      },
    ],
  });
})();
